const s = {
  name: "Image",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M22,13c0-2.8,2.2-5,5-5s5,2.2,5,5s-2.2,5-5,5S22,15.8,22,13z M27,10c-1.7,0-3,1.3-3,3s1.3,3,3,3
			c1.7,0,3-1.3,3-3S28.7,10,27,10z"/>
		<path class="st0" d="M22,26.6l-12-12l-6,6V36h32v-5.4l-9-9L22,26.6z M6,34V21.4l4-4l12,12l5-5l7,7V34H6z"/>
		<path class="st0" d="M0,5c0-2.8,2.2-5,5-5h30c2.8,0,5,2.2,5,5v30c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5z M5,2C3.3,2,2,3.3,2,5v30
			c0,1.7,1.3,3,3,3h30c1.7,0,3-1.3,3-3V5c0-1.7-1.3-3-3-3H5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Image
};
